/**
 * @file hooks/usePreviewBase
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 * @author Phil Tietjen [phil.tietjen@cbc.ca]
 */
import { PREVIEW_INDICATOR, PREVIEW_BASE } from "./constants";

/**
 * @description Checks the url argument for a preview indicator defined in the config api
 * @param {string} url A url string
 * @returns The argument url with a Preview Base string prepended
 */
function usePreviewBase(url) {
    let previewUrl = url;

    if (url && url.includes(PREVIEW_INDICATOR)) {
        previewUrl = `${PREVIEW_BASE}${url}`;
    }

    return previewUrl;
}

export default usePreviewBase;
